module.exports = __webpack_public_path__ + "img/et.7272099f.svg";